export const formatPercent = (value = 0, fixed = 1) => {
  return `${Number(value).toFixed(fixed)}%`;
};
